// export function playWav(
//   base64Audio,
//   onEnded,
//   onError
// ) {
//   if (!base64Audio.trim()) {
//     console.error("Empty Base64 audio string.");
//     return;
//   }

//   try {
//     const audioContext = new (window.AudioContext || (window).webkitAudioContext)();

//     // Convert Base64 to ArrayBuffer
//     const base64ToArrayBuffer = (base64) => {
//       const binaryString = atob(base64);
//       const len = binaryString.length;
//       const bytes = new Uint8Array(len);
//       for (let i = 0; i < len; i++) {
//         bytes[i] = binaryString.charCodeAt(i);
//       }
//       return bytes.buffer;
//     };

//     const arrayBuffer = base64ToArrayBuffer(base64Audio);

//     // Decode and play audio
//     audioContext.decodeAudioData(arrayBuffer, (audioBuffer) => {
//       const source = audioContext.createBufferSource();
//       source.buffer = audioBuffer;
//       source.connect(audioContext.destination);
//       source.start();

//       source.onended = () => {
//         onEnded?.();
//       };
//     }, (error) => {
//       console.error("Error decoding audio:", error);
//       onError?.(error);
//     });

//   } catch (error) {
//     console.error("Error in playWav function:", error);
//     onError?.(error);
//   }
// }


const activeAudioContexts = [];
const activeSources = [];

export function playWav(
  base64Audio,
  onEnded,
  onError
) {
  if (!base64Audio.trim()) {
    console.error("Empty Base64 audio string.");
    return;
  }

  try {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();

    const base64ToArrayBuffer = (base64) => {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    };

    const arrayBuffer = base64ToArrayBuffer(base64Audio);

    audioContext.decodeAudioData(
      arrayBuffer,
      (audioBuffer) => {
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioContext.destination);
        source.start();

        // Track active context and source
        activeAudioContexts.push(audioContext);
        activeSources.push(source);

        source.onended = () => {
          onEnded?.();

          // Cleanup: remove finished source/context from arrays
          const index = activeSources.indexOf(source);
          if (index > -1) {
            activeSources.splice(index, 1);
            activeAudioContexts.splice(index, 1);
          }

          // Optionally close the audio context
          audioContext.close();
        };
      },
      (error) => {
        console.error("Error decoding audio:", error);
        onError?.(error);
      }
    );
  } catch (error) {
    console.error("Error in playWav function:", error);
    onError?.(error);
  }
}

export function stopAllWav() {
  activeSources.forEach((source) => {
    try {
      source.stop(0);
    } catch (e) {
      console.warn("Source already stopped", e);
    }
  });

  activeAudioContexts.forEach((context) => {
    try {
      context.close();
    } catch (e) {
      console.warn("Context already closed", e);
    }
  });
  activeSources.length = 0;
  activeAudioContexts.length = 0;
}
